import { useEffect, useState, useRef } from 'react';
const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
};
const useDragHelper = (disabled, onDrop, { deps = [] } = {}) => {
    const ref = useRef();
    const [isOver, setIsOver] = useState(false);
    const onEnter = (e) => {
        stop(e);
        setIsOver(true);
    };
    const onLeave = (e) => {
        stop(e);
        setIsOver(false);
    };
    const onDragDrop = (e) => {
        stop(e);
        setIsOver(false);
        if (onDrop) {
            onDrop(e);
        }
    };
    useEffect(() => {
        if (ref.current && !disabled) {
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ref.current.addEventListener('dragleave', onLeave);
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ref.current.addEventListener('dragover', onEnter);
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            ref.current.addEventListener('drop', onDragDrop);
        }
        return () => {
            if (ref.current && !disabled) {
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                ref.current.removeEventListener('dragleave', onLeave);
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                ref.current.removeEventListener('dragover', onEnter);
                // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
                ref.current.removeEventListener('drop', onDragDrop);
            }
        };
    }, [ref, disabled, ...deps]);
    return [ref, isOver];
};
export default useDragHelper;
